var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.33484 6.17636C-0.111613 6.63191 -0.111613 7.37173 0.33484 7.82728L6.04944 13.6583C6.4959 14.1139 7.22094 14.1139 7.66739 13.6583C8.11384 13.2028 8.11384 12.463 7.66739 12.0074L3.89932 8.16621H14.8571C15.4893 8.16621 16 7.64506 16 7C16 6.35494 15.4893 5.83379 14.8571 5.83379H3.9029L7.66382 1.99258C8.11027 1.53703 8.11027 0.797215 7.66382 0.341663C7.21737 -0.113888 6.49233 -0.113888 6.04587 0.341663L0.331268 6.17272L0.33484 6.17636Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/leftArrow.00364cbdb1cf2d6d0ebd4b29b03929b1.svg";
export { ForwardRef as ReactComponent };